import { IGameSettings } from '~/types';

export const INITIAL_SETTINGS: IGameSettings = {
  time: 60,
  easyRounds: 5,
  mediumRounds: 5,
  hardRounds: 5,
  extremeRounds: 5,
};
